import { Loader2 } from "lucide-react";
import { useTranslation } from "@/shared/i18n";

export function LoadingRow() {
  const { t } = useTranslation("admin-financial-overview");
  return (
    <div className="flex items-center justify-center gap-2 py-8 text-sm text-muted-foreground">
      <Loader2 className="h-4 w-4 animate-spin" /> {t("loading")}
    </div>
  );
}

export function EmptyRow({ text }: { text?: string }) {
  const { t } = useTranslation("admin-financial-overview");
  return (
    <div className="flex items-center justify-center py-8 text-sm text-muted-foreground">
      {text ?? t("noDataForFilters")}
    </div>
  );
}
